module.exports = __webpack_public_path__ + "static/media/plzen.8120ea85.png";